// Display titles for the CMS-managed pages (must match the backend's
// CMS_SLUGS and apps/website routes).
export const CMS_PAGES: { slug: string; title: string }[] = [
  { slug: "home", title: "Home" },
  { slug: "company", title: "Company" },
  { slug: "solutions", title: "Solutions" },
  { slug: "platform", title: "Platform" },
  { slug: "privacy", title: "Privacy Policy" },
  { slug: "terms", title: "Terms of Use" },
  { slug: "government-data-request-policy", title: "Government Data Request Policy" },
  { slug: "contact", title: "Contact" },
  { slug: "careers", title: "Careers" },
];

export const PAGE_TITLE: Record<string, string> = Object.fromEntries(
  CMS_PAGES.map((p) => [p.slug, p.title]),
);
